import axios, { AxiosError } from "axios";
import { addSnackbar } from "Redux/snackbarReducer";
import store from "../store";

let hasShownSnackbar = false;

const errorInterceptor = (error: AxiosError<any>) => {
  try {
    console.log(error.response)
    // console.log(hasShownSnackbar, "hasShownSnackbar1")
    if (!axios.isCancel(error)) {
      // console.log(hasShownSnackbar, "hasShownSnackbar2")
      const message = error.response
        ? error.response.data.message ||
        error.response.data.responsemessage ||
        error.response.data.detail
        : error.message;
      if (error.config?.params?.raise === false) {
        throw error
      }
      if (typeof message === "string" && !hasShownSnackbar) {
        // console.log(hasShownSnackbar, "hasShownSnackbar4")
        store.dispatch(
          addSnackbar({
            message: message,
            type: "error",
          })
        );
        console.log(hasShownSnackbar, "hasShownSnackbar5")
      }
      if (error.response?.status === 401) {
        window.dispatchEvent(new CustomEvent("logout"));
        hasShownSnackbar = true;
      }
      console.error(message);
      if (error.response?.status !== 401) {
        throw error;
      }
    } else {
      throw error
    }
    // return response;
  } catch (e) {
    throw e;
  } finally {
  }
};
export default errorInterceptor;
